import { memo } from "react";
import PropTypes from "prop-types";
import { TRANSPORTATION_TYPES } from "app/constants";
import IconNegoTrain from "app/pages/.shared/IconNegoTrain";
import AirplaneFilledIcon from "app/icons/travel/AirplaneFilledIcon";
import TourFilledIcon from "app/icons/travel/TourFilledIcon";

const TransportationPicto = ({ transportationTypes, ...props }) => {
	if (
		transportationTypes.length === 1 &&
		transportationTypes[0] === TRANSPORTATION_TYPES.FLIGHT
	) {
		return <AirplaneFilledIcon {...props} />;
	} else if (
		transportationTypes.length === 1 &&
		transportationTypes[0] === TRANSPORTATION_TYPES.TRAIN
	) {
		return <IconNegoTrain {...props} />;
	} else if (transportationTypes.length > 1) {
		return <TourFilledIcon {...props} />;
	}
	return false;
};

TransportationPicto.propTypes = {
	transportationTypes: PropTypes.array,
};

TransportationPicto.defaultProps = {
	transportationTypes: [],
};

export default memo(TransportationPicto);
